module.exports = __webpack_public_path__ + "static/androsphinx-982f691d5c86ea2638cc763a6cb3d8c5.jpg";